import { createFileRoute } from '@tanstack/react-router'

import { SmzForm } from '@/pages/smz-form'

export const Route = createFileRoute('/_protected/withdrawal-smz/form')({
    component: SmzForm,
})
